import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'

export const renderTextArea = ({
  input,
  label,
  type,
  rows,
  meta: { touched, error, warning },
}) => (
  <ReactBootstrap.Form.Group className={'mt-3 mb-3'}>
    <ReactBootstrap.Form.Label>{label}</ReactBootstrap.Form.Label>
    <textarea
      rows={rows}
      spellCheck={true}
      className="form-control"
      {...input}
      placeholder={label}
      type={type}
    />
    {touched &&
      ((error && <span className="text-danger">{error}</span>) ||
        (warning && <span className="text-warning">{warning}</span>))}
  </ReactBootstrap.Form.Group>
)
